import MessageBox from "./CMessageBox/index";

export default MessageBox;
